/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SchemaColumn } from './schemaColumn';


export interface Schema { 
    /**
     * A container for Schema Columns that are present in data file(s) for this Business Object Format. Required when Schema is                   present                
     */
    columns?: Array<SchemaColumn>;
    /**
     * A container for partition columns in a specific schema. A schema might have zero, one or more partition columns. If a partition                   column is present in the data file(s), it should also be listed as a regular column in the schema with all column information matching (case                   sensitive)                
     */
    partitions?: Array<SchemaColumn>;
    /**
     * The string to use for the null value (e.g. \"\\\\\\\\N\"). Please note that a null value is allowed to be a whitespace character.                   XML escaping should be used when specifying non-ASCII characters.                   Note: when passing in an empty String, the response XML will return a NULL value (i.e. the tag will be absent). Generate DDL calls will show                   the correct empty String value wrapped in single-quotes.                   Required when Schema is present                
     */
    nullValue?: string;
    /**
     * The field delimiter (e.g. \"|\"). Please note that a field delimiter is allowed to be a whitespace character.                   XML escaping should be used when specifying non-ASCII characters                
     */
    delimiter?: string;
    /**
     * The collection items delimiter (e.g. \",\"). XML escaping should be used when specifying non-ASCII characters                
     */
    collectionItemsDelimiter?: string;
    /**
     * The map keys delimiter (e.g. \"=\"). XML escaping should be used when specifying non-ASCII characters                
     */
    mapKeysDelimiter?: string;
    /**
     * The escape character (e.g. \"\\\\\\\\\").                   XML escaping should be used when specifying non-ASCII characters.                
     */
    escapeCharacter?: string;
    /**
     * The customRowFormat is used for defining custom Hive format.                   This will override everything after \"ROW FORMAT\" in DDL including delimiter, escape value, null value statements                
     */
    customRowFormat?: string;
    /**
     * The customClusteredBy is used to support Hive \"CLUSTERED BY\" statement                
     */
    customClusteredBy?: string;
    /**
     * The customTblProperties is used to support Hive \"TBLPROPERTIES\" statement and tag the Hive table definition with your own                   metadata key/value pairs                
     */
    customTblProperties?: string;
    /**
     * The partition key group that this schema's partition or sub-partition key belongs to. This value will be used to identify the                   ordered set of Expected Partition Values when determining Business Object Data Availability or generating DDL using partition value ranges. A                   Partition Key Group value is required in the Business Object Format in order to use partition value ranges with the Availability and DDL                   services                
     */
    partitionKeyGroup?: string;
}
